import { render, staticRenderFns } from "./StudentCategoriesSubcategories.vue?vue&type=template&id=6fcf5994"
import script from "./StudentCategoriesSubcategories.vue?vue&type=script&lang=ts"
export * from "./StudentCategoriesSubcategories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports